import { agrupaLogic } from '../agrupa/agrupa.logic';
import { AgrupaHostView, AgrupaProjectorView, AgrupaStudentView } from '../eval-blocks/EvalBlocksViews';
import type { ActivityPlugin } from '../../core/types/activity.types';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';

export const agrupaPlugin: ActivityPlugin<'agrupa'> = {
  ...agrupaLogic,
  displayName: GAME_MODE_CATALOG.agrupa.displayName,
  icon: GAME_MODE_CATALOG.agrupa.icon,
  HostView: AgrupaHostView,
  StudentView: AgrupaStudentView,
  ProjectorView: AgrupaProjectorView,
};

export { demoAgrupaPayload } from '../agrupa/agrupa.logic';
